import React from 'react';
import { styles } from './HeaderUtilities.css';
import { HeaderUtilityButton, HeaderUtilityButtonProps } from '../HeaderUtilityButton/HeaderUtilityButton';

export const HeaderUtilities = ({ utilities }: { utilities: Array<HeaderUtilityButtonProps> }) => {
  return (
    <div className={styles.container}>
      {utilities.map((util, i) => {
        return (
          <HeaderUtilityButton
            key={i}
            label={util.label}
            datalayerValue={util.datalayerValue}
            datalayerLabel={util.datalayerLabel}
            icon={util.icon}
            showOnMobile={util.showOnMobile}
            shouldShowQtyBadge={util.shouldShowQtyBadge}
            badgeQty={util.badgeQty}
            newCouponCount={util.newCouponCount}
            shouldBadgeAnimate={false}
            hasSubmenu={util.hasSubmenu}
            submenuComponent={util.submenuComponent}
            onClick={util.onClick}
            customElementId={util.customElementId}
            testId={util.testId}
          ></HeaderUtilityButton>
        );
      })}
    </div>
  );
};
